export const getHeaders = (tipooferta) => {

  return [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    {
      field: "art_codigo",
      headerName: "Código",
      width: 120,
    },
    { field: "art_descripcion", headerName: "Descripcion", width: 250 },
    { field: "aofd_art_nprecio", headerName: "Precio", width: 120 },
    { field: "aofd_ofertaprecio", headerName: "Precio De Oferta", width: 120 },
    ...(Number(tipooferta) === 1
      ? [{ field: "aofd_ofertastock", headerName: "Stock De Oferta", width: 120 }]
      : []),
    { field: "web", headerName: "Web", width: 10 },
    { field: "app", headerName: "App", width: 10 },
  ];
};


